export const APPOINTMENT_STATUS = {
    TO_BE_SCHEDULED: 'to_be_scheduled',
    SCHEDULED: 'scheduled',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
} as const;

export type TAppointmentStatus = typeof APPOINTMENT_STATUS[keyof typeof APPOINTMENT_STATUS];

export const APPOINTMENT_MODALITY = {
    TELEVISITA: 'televisit',
    ON_SITE: 'on_site',
    AT_HOME: 'at_home',
    TELEASSISTANCE: 'teleassistance',
} as const;

export type TAppointmentModality = typeof APPOINTMENT_MODALITY[keyof typeof APPOINTMENT_MODALITY];

export const APPOINTMENT_TYPE = {
    TELEVISIT: 'televisit',
    TELEASSISTANCE: 'teleassistance',
} as const;

export type TAppointmentType = typeof APPOINTMENT_TYPE[keyof typeof APPOINTMENT_TYPE];

export const APPOINTMENT_CARD_STATUS = {
    UPCOMING: 'upcoming',
    SCHEDULED: 'scheduled',
    COMPLETED: 'completed',
    MISSED: 'missed',
    ENABLED: "enabled"
} as const;

export type TAppointmentCardStatus = typeof APPOINTMENT_CARD_STATUS[keyof typeof APPOINTMENT_CARD_STATUS];
